function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { ChevronDown } from '@finect/tabular-icons/chevronDown';
import { Link } from 'react-router-dom';
import { isMobile } from '@finect/front-utils/isMobile';
import { NEW_ITEMS } from '../../data';
import { Inner, LinkLabel, HighlightDot } from './partials';
export const TextMenu = _ref => {
  let {
    href = null,
    text,
    onAction,
    app,
    finectApp
  } = _ref;
  const handleDocumentTouchStart = () => {
    document.removeEventListener('touchstart', handleDocumentTouchStart);
  };
  const handleTouchStart = () => {
    document.addEventListener('touchstart', handleDocumentTouchStart);
  };
  const handleLinkClick = event => {
    if (onAction) {
      event.preventDefault();
    }
  };
  const props = isMobile() ? {
    onTouchStart: handleTouchStart
  } : {};
  const linkLabelProps = href ? finectApp === app ? {
    to: href,
    as: Link
  } : {
    href
  } : {
    as: 'span'
  };
  return React.createElement(Inner, {
    "aria-haspopup": Boolean(onAction),
    onClick: onAction,
    as: "li"
  }, React.createElement(LinkLabel, _extends({
    "data-fi-event": "omninav-mainMenu",
    onClick: handleLinkClick
  }, linkLabelProps), React.createElement("span", null, text, onAction && NEW_ITEMS.length > 0 ? React.createElement(HighlightDot, null) : null), onAction ? React.createElement(ChevronDown, {
    size: "16"
  }) : null));
};